<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-autocomplete
                  :items="departmentList"
                  :item-disabled="checkDepartmentDisabled"
                  item-text="Name"
                  item-value="ID"
                  label="部門"
                  v-model="form.DepartmentID"
                  :rules="formRules.department"
                ></v-autocomplete>
                <v-text-field
                  v-model="form.Budget"
                  label="預算"
                  :rules="formRules.budget"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                ></v-text-field>
                <v-textarea
                  v-model="form.Remark"
                  rows="3"
                  label="備註"
                ></v-textarea>
                <v-chip
                  v-show="isOverBudget"
                  color="red"
                  small
                >
                  預算超標
                </v-chip>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="save"
        >儲存</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import TodoItemAutoComplete from "@/data/todo-item/TodoItemAutoComplete.js";
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    editingId: {
      type: Number,
      required: true,
      default: -1
    },
    projectId: {
      type: Number,
      required: true
    },
    stage: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    form: {},
    defaultForm: {
      Budget: 0,
      DepartmentID: 0
    }
  }),
  computed: {
    formRules() {
      return {
        budget: [
          v => !!v || "請輸入預算",
          v => parseInt(v) <= 1000000000 || "預算不可超過10億"
        ],
        department: [v => !!v || "請選擇部門"]
      };
    },
    formTitle() {
      return this.editingId === -1 ? "新增部門預算" : "編輯部門預算";
    },
    departmentList() {
      if (this.form.DepartmentID > 0) {
        let idx = this.activeDepartmentList.findIndex(
          o => o.ID === this.form.DepartmentID
        );
        if (idx < 0) {
          var inactiveDepartment = this.$store.state.department.list.find(
            o => o.ID === this.form.DepartmentID
          );
          if (inactiveDepartment) {
            return [inactiveDepartment].concat(this.activeDepartmentList);
          }
        }
      }
      return this.activeDepartmentList;
    },
    project() {
      return this.projects.find(o => o.ID == this.projectId) || {};
    },
    isOverBudget() {
      let projectDepartmentBudgets = this.$store.state.projectDepartmentBudget.list.filter(
        o => o.ProjectID == this.projectId
      );
      let usedBudget = projectDepartmentBudgets.reduce(
        (sum, item) => (item.ID == this.form.ID ? sum : sum + item.Budget),
        0
      );
      return (
        parseInt(usedBudget) + parseInt(this.form.Budget) >
        (this.project.FinalAmount || this.project.Amount)
      );
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    editingIdx() {
      return this.$store.state.projectDepartmentBudget.list.findIndex(
        o => o.ID == this.editingId
      );
    },
    ...mapGetters(["activeDepartmentList", "projects"])
  },
  methods: {
    checkDepartmentDisabled(item) {
      return (
        this.$store.state.projectDepartmentBudget.list.findIndex(
          o =>
            o.DepartmentID == item.ID &&
            o.ProjectStage == this.stage &&
            o.ProjectID == this.projectId
        ) >= 0
      );
    },
    close() {
      this.isShowDialog = false;
    },
    save() {
      if (!this.$refs.form.validate()) return;

      this.form.Budget = parseInt(this.form.Budget);
      this.form.ProjectID = this.projectId;
      this.form.ProjectStage = this.stage;
      if (this.form.Budget > 1000000000) {
        return alert("預算不可大於10億");
      }

      if (
        this.isOverBudget &&
        !window.confirm(
          `專案部門總預算已經超過專案金額(${this.project.FinalAmount ||
            this.project.Amount})，確定仍要新增?`
        )
      )
        return;

      this.isLoading = true;
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          this.isLoading = false;
          return alert("發生異常：無法找到編輯物件");
        }
        this.$services.projectDepartmentBudget
          .edit(this, this.form)
          .then(res => {
            this.$set(
              this.$store.state.projectDepartmentBudget.list,
              this.editingIdx,
              res.data.result
            );
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$services.projectDepartmentBudget
          .add(this, this.form)
          .then(res => {
            this.$store.state.projectDepartmentBudget.list.splice(
              0,
              0,
              res.data.result
            );
            TodoItemAutoComplete.notifyActionDetected(this, 'project', this.projectId)
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resetForm() {
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          alert("發生異常：無法找到編輯物件");
          return this.close();
        }
        this.form = JSON.parse(
          JSON.stringify(
            this.$store.state.projectDepartmentBudget.list[this.editingIdx]
          )
        );
      } else {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      }
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
    this.isLoading = true;
    this.$services.department.prepareData(this).finally(() => {
      this.isLoading = false;
    });
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>